import { faClockRotateLeft, faFileImport } from "@fortawesome/pro-solid-svg-icons";
import defaultProfile, { asyncRoute } from "./default";
import { type ConfigSection, type GameProfile, type Menu, MenuItem, type ProfileCtx } from "./types";
import { getOwnerIdWarning } from "@/util/dragonwildsOwnerId";
import { commonMenuItems } from "./common";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  // Save Backups + Save Import (TR-5390) sit directly below File Manager, matching Valheim's,
  // Palworld's and SCUM's ordering, with Logs kept last. Labels come from the generic ngp/route/*
  // keys, which already load for every game.
  menu[0].items.push(
    new MenuItem(
      "save-backups",
      faClockRotateLeft,
      asyncRoute(() => import("../components/views/runescape_dragonwilds/SaveBackups.vue")),
    ),
    new MenuItem(
      "save-import",
      faFileImport,
      asyncRoute(() => import("../components/views/runescape_dragonwilds/SaveImport.vue")),
    ),
  );
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  // The server refuses to operate without a valid OwnerId and never shows up in the in-game browser,
  // so the field warns while the customer types. See dragonwildsOwnerId.ts.
  {
    component: "ConfSection",
    props: {
      name: "general",
      fieldWarnings: { "/Script/Dominion.DedicatedServerSettings.OwnerId": getOwnerIdWarning },
    },
  },
  // The World section (TR-5390): which world the server boots, its metadata, and the switch action.
  //
  // 🔴 TR-5389's world settings (difficulty, PvP, hardcore and the 59 gameplay multipliers, which
  // live inside the world `.sav` rather than in any config file) open in a **modal** from this
  // section's title row rather than as a section of their own. They started as one, but choosing
  // Custom reveals all 59 multipliers and pushed that section's Save button so far down the page
  // that QA could not find it -- and it could not ride the page's action bar either, because none
  // of those values are config fields. A modal footer stays in view whatever the list does.
  { component: "DragonwildsWorldSection", props: { name: "dragonwilds_world" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  hasActivePlayers: false,
  // The game has no RCON and no query protocol - the server runs on a single game port. Both ports
  // are allocated and shown by default, so we were advertising two ports that do nothing.
  statusPageConfig: {
    ...defaultProfile(_ctx).statusPageConfig,
    showRconPort: false,
    showQueryPort: false,
  },
});
